import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function NavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand">HoneyDo</Link>
      <div className="navbar-links">
        <Link to="/new">New task</Link>
        {user.role === 'admin' && <Link to="/admin/users">Users</Link>}
        {user.role === 'admin' && <Link to="/admin/templates">Templates</Link>}
        <button
          className="link-button"
          onClick={() => {
            logout();
            navigate('/login');
          }}
        >
          Log out
        </button>
      </div>
    </nav>
  );
}
